// shabba-dashboard/src/constants/instruments.ts

export const INSTRUMENTS = [
  { label: 'CRDB',     secId: 'LPPJ' },
  { label: 'VODA',     secId: 'WVSL' },
  { label: 'AFRIPRISE',secId: 'KKRA' },
  { label: 'DCB',      secId: 'FMDA' },
  { label: 'NICO',     secId: 'IGTT' },
  { label: 'NMB',      secId: 'BDHK' },
];

const LABEL_BY_SECID = INSTRUMENTS.reduce<Record<string,string>>((m, {label, secId}) => {
  m[secId.toUpperCase()] = label;
  return m;
}, {});

export function labelForSecId(secId: string): string {
  return LABEL_BY_SECID[(secId || '').toUpperCase()] || secId || 'N/A';
}